import { ElementRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { ApiService } from '../services/api-mock.service';
import { GlobalsService } from '../services/globals.service';
import { SharedAPIService } from '../services/shared-api.service';

import { Router } from '@angular/router';

export interface BaseScreenModel {
  // States.
  isLoading: boolean;
  isSubmitted: boolean;
  isValid: boolean;
}

export class ScreenModel implements BaseScreenModel {
  pageID : string = '';
  screenName: string = '';
  data: ResponseBase | undefined;
  savedData : any;
  form: FormGroup | undefined;
  skipValidation = false; // Allow skipping validation in KYC screens.
  allErrors: any;
  lastSavedTime?: string;
  pageID_read = '';
  pageID_write = '';
  pageID_docusign = '';
  // States.
  isLoading = true;
  isSubmitted = false;
  isValid = false;
  errorMessage: string = '';
  doNotSkipWriteService = true;
  submitResponseData : any;
  productDetailResponse : any;

  // hooks.
  initializeForm = () => {};
  syncFormWithModel = () => {};
  goToNextScreen = () => {};
  redirectToDocusign = () => {};
  goToPreviousScreen = () => {};
  markControlsAsSubmitted = () => {};
  getSavePageID = () => {};
  getLoadDataFromSession=()=>{};
  

  constructor(
    protected globals: GlobalsService,
    protected apiService: ApiService,
    private el: ElementRef,
  ) {}

  async callMiscService(pageID:string, serviceBody:any ){
    const reqData: RequestData = Object.assign(
      this.getDefaultPostRequest(),
      {
        ServiceBody :serviceBody?serviceBody:{}
      },
    );
  
    const newData :RequestData = Object.assign({},reqData,{ServiceHeader : {
      ...reqData.ServiceHeader,
      PageName : this.screenName,
      RequestID : pageID,
      TokenID : pageID == 'R0000'?'':this.apiService.getTokenID()
    }})
    this.isLoading = true;
    let data = (await this.apiService.read(
      newData
    )) as ResponseBase;
    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
    const { Errors : errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage,ServiceBody : responseServiceBody } = data as ResponseData
    this.isLoading = false;
    
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      return responseServiceBody
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }
  
   
  };
  async callMiscServiceNoSessionFP(pageID:string, serviceBody:any ){
    const reqData: RequestData = Object.assign(
      this.getDefaultPostRequest(),
      {
        ServiceBody :serviceBody?serviceBody:{}
      },
    );
  
    const newData :RequestData = Object.assign({},reqData,{ServiceHeader : {
      ...reqData.ServiceHeader,
      PageName : this.screenName,
      RequestID : pageID,
      
    }})
    this.isLoading = true;
    let data = (await this.apiService.read(
      newData
    )) as ResponseBase;
    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
    const { Errors : errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage,ServiceBody : responseServiceBody } = data as ResponseData
    this.isLoading = false;
    
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      return responseServiceBody
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal("The details you entered do not match. please try again.","Forgot password");
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }
  
   
  };
  async callMiscServiceNoSession(pageID:string, serviceBody:any ){
    const reqData: RequestData = Object.assign(
      this.getDefaultPostRequest(),
      {
        ServiceBody :serviceBody?serviceBody:{}
      },
    );
  
    const newData :RequestData = Object.assign({},reqData,{ServiceHeader : {
      ...reqData.ServiceHeader,
      PageName : this.screenName,
      RequestID : pageID,
      
    }})
    this.isLoading = true;
    let data = (await this.apiService.read(
      newData
    )) as ResponseBase;
    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
    const { Errors : errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage,ServiceBody : responseServiceBody } = data as ResponseData
    this.isLoading = false;
    
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      return responseServiceBody
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }
  
   
  };

  async callBVDetailsService(){
    const reqData: any = {}
  
   
    this.isLoading = true;
    let data = (await this.apiService.BVLoginData(
      reqData
    )) as any;
    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
    
    this.isLoading = false;
    if (data['ClientID']) {
      return data
    }else {
      // print error
    }
  
   
  };

  async callStaticDataService(pageID:string, serviceBody:any ){
    const reqData: RequestData = Object.assign(
      this.getDefaultPostRequest(),
      {
        ServiceBody :{Type : 'ALL'}
      },
    );
  
    const newData :RequestData = Object.assign({},reqData,{ServiceHeader : {
      ...reqData.ServiceHeader,
      PageName : this.screenName,
      RequestID : pageID,
      TokenID : pageID == 'R0000'?'':this.apiService.getTokenID(),
      Type : 'ALL'
    }})
    this.isLoading = true;
    let data = (await this.apiService.staticData(
      newData
    )) as ResponseBase;
    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
    const { Errors:errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage,ServiceBody : responseServiceBody } = data as ResponseData
    this.isLoading = false;
    
    if (serviceBody) {
      return responseServiceBody
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }else{
      this.globals.showErrorModal("error occurred");
    }
  
   
  };

  async loadData() {
    const reqData: RequestData = Object.assign(
      this.getDefaultPostRequest(),
      {
        ServiceBody :{}
      },
    );
  
    const newData :RequestData = Object.assign({},reqData,{ServiceHeader : {
      ...reqData.ServiceHeader,
      PageName : this.screenName,
      RequestID : this.pageID_read,
      TokenID : this.apiService.getTokenID()
    }})
    
    this.isLoading = true;
    let data = (await this.apiService.read(
      newData
    )) as ResponseBase;

    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
    data = this.modifyServerData(data);


    const { Errors:errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage,ServiceBody : responseServiceBody } = data as ResponseData
    // On Success
 
      this.isLoading = false;
   
    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      this.updateLocalData(data);

    //this.globals.showLastTimeSavedMobile = !!data.LastSavedTime;

    if (this.globals.showLastTimeSavedMobile) {
      this.globals.showLastSaveTime();
    }
      this.data = data;
      this.deriveFromData(this.mapPegaObjToUI(responseServiceBody));
      this.initializeDefaultData();
      this.initializeMockData();
      this.initializeForm();
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      
      if(responseServiceMessage.ErrorDescription == "Invalid Session"){
        await this.globals.routeToLogin();
      }
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
     
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }

   
    
    await this.globals.updateSideBarStepper(data, this.screenName);
    
  }

  async loadDataSaved() {
   
    this.isLoading = true;
    let data =this.getLoadDataFromSession()
    console.log(`[ScreenModel(${this.screenName})] loadData, data:`, data);
   // data = this.modifyServerData(data);


     // On Success
    if (data!=null) {
      this.updateLocalData(data);

      this.savedData = data;
      this.deriveFromData(this.mapPegaObjSavedToUI(data));
      this.initializeDefaultData();
      this.initializeMockData();
      this.initializeForm();
    }else {
      // print error
    }

   
    this.isLoading = false;

    
  }

  modifyServerData(data: ResponseBase): ResponseBase {
    return data;
  }

  deriveFromData(data: ResponseBase) {
    console.error('Sub class must implement deriveFromData.');
  }

  mapPegaObjToUI(data: ResponseBase) {
    console.error('Sub class must implement deriveFromData.');
    return data;
  }

  mapPegaObjSavedToUI(data: any) {
    console.error('Sub class must implement deriveFromData.');
    return data;
  }

  initializeDefaultData() {}

  initializeMockData() {}

  getDefaultPostRequest(): PostRequestBase {

    const uniqueLink = window.localStorage.getItem('digital-fna-unique-link')
    //376623bdd0e71cc32ef73427f0bdbee9f5a010b2237a62152eb541497ec44927c688a4eeb933b0b05e077c2ac76c4d6d92d910517e85f6d0e4125536624b9461
    return {
      ServiceHeader: {
        UniqueLink: uniqueLink,
        ChannelID: 'GTFNA',
        PageName: '',
        RegionCode: 'SG',
        RequestID: '',
        Status: '',
        TokenID : '',
      },
    } as PostRequestBase;
  }
  

  syncModelWithForm() {}

  deriveDataFromModel(): object {
    console.error('Sub class must implement deriveDataFromModel.');
    return {};
  }

  deriveDataFromModelDocusign(): object {
    console.error('Sub class must implement deriveDataFromModel.');
    return {};
  }

  // Updates global data with new data from server.
  // It is quite safe to use this default implementation, but if you need
  // to clean up the data object before merging with local data, override this.
  updateLocalData(data: any) {
    this.globals.updateModel(data);
  }

  // Updates global data with data that has been submitted.
  // It is quite safe to use this default implementation, but if you need
  // to clean up the submitted data object before merging with local
  // data, override this.
  updateLocalDataAfterSubmission(data: any) {
    this.globals.updateModel(data);
  }
  async submitDataDocusign() {
    this.isLoading = true;
    const data = Object.assign(
      this.getDefaultPostRequest(),
      this.deriveDataFromModelDocusign(),
    );
    console.log('[ScreenModel] updateData, deriveDataFromModel, data:', data);

    // const status = await this.apiService.submitFNAInfo(data);
    // if (!status) {
    //   return status;
    // }
    const newData :PostRequestBase = Object.assign({},data,{ServiceHeader : {
      ...data.ServiceHeader,
      PageName : this.screenName,
      RequestID : this.pageID_docusign,
      TokenID : this.apiService.getTokenID()
    }})
 
    let outputData = (await this.apiService.save(
      newData
    )) as ResponseData;
    const { Errors:errors,ServiceBody:serviceBody,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } = outputData
    // On Success
    this.isLoading = false;
   

    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      this.submitResponseData = serviceBody
      this.updateLocalDataAfterSubmission(data);
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }

  

    
    return null;
  }


  async submitData() {
    this.isLoading = true;
    const data = Object.assign(
      this.getDefaultPostRequest(),
      this.deriveDataFromModel(),
    );
    console.log('[ScreenModel] updateData, deriveDataFromModel, data:', data);

    // const status = await this.apiService.submitFNAInfo(data);
    // if (!status) {
    //   return status;
    // }
    const newData :PostRequestBase = Object.assign({},data,{ServiceHeader : {
      ...data.ServiceHeader,
      PageName : this.screenName,
      RequestID : this.pageID_write,
      TokenID : this.apiService.getTokenID()
    }})
 
    let outputData = (await this.apiService.save(
      newData
    )) as ResponseBase;
    const { Errors:errors,ServiceHeader: responseServiceHeader,ServiceMessage:responseServiceMessage } = outputData
    // On Success
    this.isLoading = false;

    if (responseServiceHeader && responseServiceHeader['Status'] == 'Success') {
      this.updateLocalDataAfterSubmission(data);
    }else if(responseServiceMessage && responseServiceMessage.ErrorDescription) {
      this.globals.showErrorModal(responseServiceMessage.ErrorDescription);
      return true;
      // print error
    }else if(errors && errors.length>0){
      this.globals.showErrorModal("Internal Server Error");
    }

  

    
    return null;
  }

  validate() {
    console.error('Sub class must implement validate.');
  }

  // Optional to implement. To perform additional actions after
  // validation has been done during onSubmit.
  additionalValidationDoneDuringSubmit() {}

  // Optional to implement. To set controls as touched so errors show.
  markControlsAsTouched() {
    this.form?.markAllAsTouched();
  }

  async onSubmitDocusign(){
    this.isSubmitted = true;
    this.skipValidation = false;

    this.markControlsAsTouched();
    this.markControlsAsSubmitted();

    await this.validate();

    if (this.form) {
      console.log(
        `[${this.screenName}] form.valid:`,
        this.form.valid,
        ', form.value:',
        this.form.value,
        ', form:',
        this.form,
      );
      this.findInvalidControlKeyArray();
      console.log(`[${this.screenName}] this.form.errors:`, this.form.errors);
    }

    this.additionalValidationDoneDuringSubmit();

    if (!this.isValid) {
      console.log(
        `[${this.screenName}] Form submit blocked due to validation errors.`,
      );
      this.scrollToFirstInvalidControl();
      return;
    }

    this.syncModelWithForm();
    if(this.doNotSkipWriteService){
      const updateDataStatus = await this.submitDataDocusign();
   
    if (updateDataStatus) {
      // @For integration: handle error.
      return;
    }
    }
    

    this.form?.markAsPristine();

    this.redirectToDocusign();
  }

  async onSubmit() {
    
    this.isSubmitted = true;
    this.skipValidation = false;

    this.markControlsAsTouched();
    this.markControlsAsSubmitted();

    await this.validate();

    if (this.form) {
      console.log(
        `[${this.screenName}] form.valid:`,
        this.form.valid,
        ', form.value:',
        this.form.value,
        ', form:',
        this.form,
      );
      this.findInvalidControlKeyArray();
      console.log(`[${this.screenName}] this.form.errors:`, this.form.errors);
    }

    this.additionalValidationDoneDuringSubmit();
    this.syncModelWithForm();
    if (!this.isValid) {
      console.log(
        `[${this.screenName}] Form submit blocked due to validation errors.`,
      );
      this.scrollToFirstInvalidControl();
      return;
    }

    
    if(this.doNotSkipWriteService){
      const updateDataStatus = await this.submitData();
   
    if (updateDataStatus) {
      // @For integration: handle error.
      return;
    }
    }
    

    this.form?.markAsPristine();

    this.goToNextScreen();
  }

  async onSaveAsDraft() {
  //   // this.isSubmitted = true;

  //   // this.markControlsAsTouched();
  //   // this.markControlsAsSubmitted();

  //   // await this.validate();

  //   if (this.form) {
  //     console.log(
  //       `[${this.screenName}] form.valid:`,
  //       this.form.valid,
  //       ', form.value:',
  //       this.form.value,
  //       ', form:',
  //       this.form,
  //     );
  //     // this.findInvalidControlKeyArray();
  //     console.log(`[${this.screenName}] this.form.errors:`, this.form.errors);
  //   }

  //   // this.additionalValidationDoneDuringSubmit();

  //   if (!this.isValid) {
  //     // console.log(
  //     //   `[${this.screenName}] Form submit blocked due to validation errors.`,
  //     // );
  //     //return;
  //   }

  //   this.syncModelWithForm();

  //  if(this.doNotSkipWriteService){const updateDataStatus = await this.submitData();
  //   if (updateDataStatus) {
  //     // @For integration: handle error.
  //     return;
  //   }
  // }

  //   this.form?.markAsPristine();
  //   // this.goToNextScreen();
  }

  // region Utilities

  findInvalidControlKeyArray(): string[] {
    if (!this.form) {
      return [];
    }

    let keys: string[] = [];
    for (const [key, value] of Object.entries(this.form.controls)) {
      const invalidChild = this.findInvalidControlKeys(value, key);
      keys = keys.concat(invalidChild);
      // console.log('[findInvalidControlKey] key:', key)
      // console.log('[findInvalidControlKey] value:', value)
    }
    console.log('[findInvalidControlKeyArray] keys:', keys);
    return keys;
  }

  private findInvalidControlKeys(
    control: AbstractControl,
    key: string,
  ): string[] {
    if (control instanceof FormControl && control.status === 'INVALID') {
      return [key];
    }
    if (control instanceof FormArray) {
      let keys: string[] = [];
      control.controls.forEach((item, index) => {
        const invalidChild = this.findInvalidControlKeys(
          item,
          `${key}.${index}`,
        );
        keys = keys.concat(invalidChild);
      });
      return keys;
    }
    if (control instanceof FormGroup) {
      let keys: string[] = [];
      for (const [childKey, value] of Object.entries(control.controls)) {
        const invalidChild = this.findInvalidControlKeys(
          value,
          `${key}.${childKey}`,
        );
        keys = keys.concat(invalidChild);
      }
      return keys;
    }
    return [];
  }

  getPegaDate(uiDate :any){
    return uiDate.substring(6,10)+uiDate.substring(3,5)+uiDate.substring(0,2)
}

getUIDate(getPegaDate :any){

    let formatDate : string
    if(getPegaDate && getPegaDate!=""){
      formatDate = getPegaDate.substring(6,8)+"/"+getPegaDate.substring(4,6)+"/"+getPegaDate.substring(0,4);
   
    }else{
      formatDate = ""
    }
    if(formatDate=="//"){
      formatDate= ""
    }
     return formatDate
}

  valueFromServerIsEmpty(value: any) {
    if (typeof value === 'undefined') {
      return true;
    }

    if (value === null) {
      return true;
    }

    if (typeof value === 'string' && value.length === 0) {
      return true;
    }

    return false;
  }

  get shouldShowErrors(): boolean {
    return this.isSubmitted && !this.skipValidation;
  }

  private scrollToFirstInvalidControl() {
    const invalidForm: HTMLElement | null =
      this.el.nativeElement.querySelector('form.ng-invalid');

    const firstInvalidControl: HTMLElement | null =
      this.el.nativeElement.querySelector('form .ng-invalid');

    const childInvalidControl: HTMLElement | null =
      firstInvalidControl?.querySelector('.ng-invalid') || null;

    const invalidControl =
      childInvalidControl || firstInvalidControl || invalidForm;

    if (invalidControl === null) {
      return;
    }

    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(window, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => invalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 200;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  // endregion Utilities
}

export interface BaseScreenComponent {
  // Screen properties.
  screenName?: string;

  // Screen states.

  // Methods.
  initializeForm?(): void;

  syncFormWithModel?(): void;

  onSubmit?(): void;

  goToNextScreen(): void;

  goToPreviousScreen(): void;
}

export interface ResponseBase {
  Errors?:[];
  ServiceHeader?: {
    UniqueLink: string;
    ChannelID: string;
    PageName: string;
    RegionCode: string;
    RequestID:string;
    Status: string;
    TokenID : string;
  };
  ServiceMessage?:{
    ErrorCode:string;
    ErrorDescription:string;
  }
}

export interface PostRequestBase {
  ServiceHeader?: {
    UniqueLink: string;
    ChannelID: string;
    PageName: string;
    RegionCode: string;
    RequestID:string;
    Status: string;
    TokenID : string;
  };

  
}
export interface RequestData extends PostRequestBase {
  ServiceBody : any
}

export interface ResponseData extends ResponseBase {
  // only applies when login is successful
  ServiceBody : any
}

